import { Organization } from 'torqcloud-ui'

export function canViewOrganizationUsage(organization?: Pick<Organization, 'permissions'> | null) {
  if (!organization) {
    return false
  }

  return organization.permissions?.view_organization_usage === true
}
